export const STATES = [
  { name: "ANDAMAN AND NICOBAR", id: 1 },
  { name: "ANDAMAN & NICOBAR", id: 1 },
  { name: "ANDHRA PRADESH", id: 2 },
  { name: "ARUNACHAL PRADESH", id: 3 },
  { name: "ASSAM", id: 4 },
  { name: "BIHAR", id: 5 },
  { name: "CHANDIGARH", id: 6 },
  { name: "DADRA AND NAGAR", id: 7 },
  { name: "DADRA & NAGAR", id: 7 },
  { name: "DAMAN & DIU", id: 8 },
  { name: "DAMAN AND DIU", id: 8 },
  { name: "DELHI", id: 9 },
  { name: "GOA", id: 10 },
  { name: "GUJARAT", id: 11 },
  { name: "HARAYANA", id: 12 },
  { name: "HARYANA", id: 12 },
  { name: "HIMACHAL PRADESH", id: 21 },
  { name: "JAMMU AND KASHMIR", id: 22 },
  { name: "JAMMU & KASHMIR", id: 22 },
  { name: "KARNATAKA", id: 23 },
  { name: "KERALA", id: 24 },
  { name: "LAKSHADWEEP", id: 25 },
  { name: "MADHYA PRADESH", id: 26 },
  { name: "MAHARASHTRA", id: 27 },
  { name: "MANIPUR", id: 28 },
  { name: "MEGHALAYA", id: 29 },
  { name: "MIZORAM", id: 30 },
  { name: "NAGALAND", id: 31 },
  { name: "ORISSA", id: 32 },
  { name: "PONDICHERRY", id: 33 },
  { name: "PUNJAB", id: 34 },
  { name: "RAJASTHAN", id: 35 },
  { name: "SIKKIM", id: 36 },
  { name: "TAMIL NADU", id: 37 },
  { name: "TRIPURA", id: 38 },
  { name: "UTTAR PRADESH", id: 39 },
  { name: "WEST BENGAL", id: 40 },
  { name: "JHARKHAND", id: 42 },
  { name: "UTTARAKHAND", id: 43 },
  { name: "CHHATTISGARH", id: 44 },
  { name: "TELANGANA", id: 45 },
  { name: "NOST", id: 0 },
];
